import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Message from '../../../utils/Message';
import Loader from '../../../utils/Loader';
import SummaryLineChart from './SummaryLineChart';
import SummaryPieChart from './SummaryPieChart';
import TableChart from './TableChart';
import SummaryLeftBar from './SummaryLeftBar';

import SalesLineChart from './SalesLineChart';
import SalesPieChart from './SalesPieChart';
import SalesLeftBar from './SalesLeftBar';
import domtoimage from 'dom-to-image';
import html2canvas from 'html2canvas';
import { HiDownload } from 'react-icons/hi';
import LineTableView from './LineTableView';
import LineChartMetric from './LineChartMetric';
import TopSalesTable from './TopSalesTable';
import MetricTableView from './MetricTableView';
import SalesTableView from './SalesTableView';

const SummaryDashboard = ({ report, projectId, filter, setFilter }) => {
	const [errorMsg, setErrorMsg] = useState('');
	const [clientData, setClientData] = useState('');
	const [metricField, setMetricFields] = useState([]); // metric filter names
	const [metricQuery, setMetricQuery] = useState([]); // start date end date

	const [salesSku, setSalesSku] = useState([]); // sales names
	const [salesQuery, setSalesQuery] = useState([]); // start date end date

	const [channels, setChannels] = useState([]);

	const [loading, setLoading] = useState(false);
	const [updated, setUpdated] = useState(false);
	const [metricData, setMetricData] = useState([]);
	const [salesData, setSalesData] = useState([]);
	const [metricInitialVal, setMetricInitialVal] = useState('');
	const [salesInitialVal, setSalesInitialVal] = useState('');
	const [hideFilerFields, setHideFilterFields] = useState(false);
	const user = JSON.parse(localStorage.getItem('centralize-admin-data'));
	const [showTable, setShowTable] = useState(false);
	const [showTable2, setShowTable2] = useState(false);
	const [showSalesTable, setShowSalesTable] = useState(false);

	// this is for first load
	useEffect(() => {
		// if report and sidebar is clicked get data
		// if (!parentUpdated) return;
		// console.log('loading 1');
		if (!report) return;
		if (report) {
			// add status field if it's required in req.body
			if (report) {
				setMetricFields(report.keyMetrics);
				setMetricQuery(report.metricQuery);
				setSalesSku(report.salesSku);
				setSalesQuery(report.salesQuery);
				setChannels(report.channels);
				if (report.salesSku) {
					setSalesInitialVal();
					// report.salesSku[0] && report.salesSku[0].dropdown[0]
				}
				if (report.keyMetrics) {
					setMetricInitialVal(report.keyMetrics[0] && report.keyMetrics[0].dropdown[0]);
				}
				getMetricData();
				getSalesData();
			}
		}
	}, [report]);

	function getMetricData(queryData) {
		const query = {
			token: user.accessToken,
		};
		if (queryData) {
			Object.assign(query, queryData);
		}

		setLoading(true);
		axios
			.post(report.metricsEndPoint, query)
			.then((data) => {
				if (data.data) {
					setMetricData(data.data.data);
					setLoading(false);
					setErrorMsg('');
				}
			})
			.catch((err) => {
				setErrorMsg(err.response ? err.response.data.error : '');
				setLoading(false);
			});
	}

	function getSalesData(queryData) {
		const query = {
			token: user.accessToken,
		};
		if (queryData) {
			Object.assign(query, queryData);
		}

		// console.log('query', query);
		setLoading(true);
		axios
			.post(report.salesEndPoint, query)
			.then((data) => {
				if (data.data) {
					setSalesData(data.data.data);
					setLoading(false);
					setErrorMsg('');
				}
			})
			.catch((err) => {
				setErrorMsg(err.response ? err.response.data.error : '');
				setLoading(false);
			});
	}

	const resetSalesInput = () => {
		const arr = [];
		salesQuery.forEach((e) => {
			e.value = '';
			arr.push(e);
		});
		setSalesQuery(arr);
		setFilter(false);
	};

	const resetMetricInput = () => {
		const arr = [];
		metricQuery.forEach((e) => {
			e.value = '';
			arr.push(e);
		});
		setMetricQuery(arr);
		setFilter(false);
	};

	function filterSales() {
		let newQuery = {};
		// salesSku.forEach((e) => {
		// 	if (!e.value) return;
		// 	newQuery[e.field] = e.value;
		// });
		salesQuery.forEach((e) => {
			if (!e.value) return;
			newQuery[e.field] = e.value;
		});
		getSalesData(newQuery);
	}

	function filterMetric() {
		let newQuery = {};
		// metricField.forEach((e) => {
		// 	if (!e.value) return;
		// 	newQuery[e.field] = e.value;
		// });
		metricQuery.forEach((e) => {
			if (!e.value) return;
			newQuery[e.field] = e.value;
		});
		getMetricData(newQuery);

		// channels.forEach((e) => {
		// 	if (!e.value) return;
		// 	newQuery[e.field] = e.value;
		// });
	}

	function metricFieldChange(e, index) {
		// reset the filter and isUpdated
		setFilter(false);
		setUpdated(false);
		let newArr = [...metricField];
		const { value } = e.target;
		newArr[index].value = value;
		setMetricFields(newArr);
	}

	function channelsChange(e, index) {
		setFilter(false);
		setUpdated(false);
		let newArr = [...channels];
		const { value } = e.target;
		newArr[index].value = value;
		setChannels(newArr);
	}

	function queryMetricChange(e, index) {
		// reset the filter and isUpdated
		setFilter(false);
		setUpdated(false);
		let newArr = [...metricQuery];
		const { value } = e.target;
		newArr[index].value = value;
		setMetricQuery(newArr);
		// filter out metricData
	}

	function querySalesChange(e, index) {
		// reset the filter and isUpdated
		setFilter(false);
		setUpdated(false);
		let newArr = [...salesQuery];
		const { value } = e.target;
		newArr[index].value = value;
		setSalesQuery(newArr);
	}

	function salesFieldChange(e, index) {
		// reset the filter and isUpdated
		setFilter(false);
		setUpdated(false);
		let newArr = [...salesSku];

		// console.log('newArr', newArr);
		const { value } = e.target;
		newArr[index].value = value;
		setSalesSku(newArr);
	}

	function clickFilter() {
		// if filter return new table data
		setFilter(true);
		setUpdated(true);
	}

	function downloadChart(imageName, divName) {
		var node = document.getElementById(divName);
		domtoimage
			.toPng(node)
			.then(function (dataUrl) {
				const link = document.createElement('a');
				link.href = dataUrl;

				link.download = imageName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch(function (error) {
				setErrorMsg('Oops, something went wrong.');
			});
	}

	function downloadAllCharts(chartName) {
		if (chartName === 'summary-chart') {
			setHideFilterFields(true);
		}

		setTimeout(function () {
			var node = document.getElementById('summary-chart-table');
			html2canvas(node).then((canvas) => {
				let image = canvas.toDataURL('image/png');

				const link = document.createElement('a');
				link.href = image;

				link.download = chartName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				setHideFilterFields(false);
			}, 3000);
		});
	}
	// console.log('salesSku', salesSku);
	// console.log('salesQuery', salesQuery);
	// console.log('salesData', salesData);

	// console.log('report', report);
	// console.log('metricData', metricData);

	// console.log('metricField', metricField);
	// console.log('	metricQuery', metricQuery);
	// console.log('metricData', metricData);
	// console.log('metricField', metricField);
	// console.log('channels', channels);
	// console.log('metricInitialVal', metricInitialVal);

	return (
		<div className='mb-5'>
			{!report ? (
				<Message color='info'> Please select report to display. </Message>
			) : (
				<>
					{errorMsg ? <Message color='danger'> {errorMsg} </Message> : null}
					<div>
						<div className='d-flex justify-content-between box-shadow'>
							<h5 className='text-capitalize'>Summary Dashboard</h5>

							<div className='d-flex'>
								<div>
									<div
										className='badge rounded-pill bg-primary download-btn'
										onClick={() => downloadChart('metric-line-chart', 'metric-line-chart')}>
										Line <HiDownload />
									</div>
									<div
										className='mx-1 badge rounded-pill bg-primary download-btn'
										onClick={() => downloadChart('metric-table-chart', 'metric-table-chart')}>
										Table <HiDownload />
									</div>
									<div
										className='badge rounded-pill bg-primary download-btn'
										onClick={() => downloadChart('metric-horizon-chart', 'metric-horizon-chart')}>
										H-Line <HiDownload />
									</div>
									<div
										className=' mx-1 badge rounded-pill bg-primary download-btn'
										onClick={() => downloadChart('metric-pie-chart', 'metric-pie-chart')}>
										DoNut <HiDownload />
									</div>
								</div>
								<div className='mx-3' onClick={() => downloadAllCharts('summary-chart')}>
									<div className='badge rounded-pill bg-success download-btn'>
										All chart <HiDownload />
									</div>
								</div>
							</div>
						</div>

						<div className='d-flex flex-wrap mt-3  mb-3'>
							<div className='d-flex flex-wrap'>
								{metricField.length
									? metricField.map((query, i) => {
											return (
												<div key={i}>
													{query.type === 'dropdown' && (
														<div className='mx-1' style={{ width: '12rem' }}>
															<select
																type='select'
																name={query.field}
																className='form-select mr-1'
																value={query.value}
																onChange={(e) => metricFieldChange(e, i)}>
																<option value=''>Metrics</option>
																{query.dropdown.map((e, i) => {
																	return <option key={i}>{e}</option>;
																})}
															</select>
														</div>
													)}
												</div>
											);
									  })
									: null}

								{channels.length
									? channels.map((query, i) => {
											return (
												<div key={i}>
													{query.type === 'dropdown' && (
														<div className='mx-1' style={{ width: '12rem' }}>
															<select
																type='select'
																name={query.field}
																className='form-select mr-1'
																value={query.value}
																onChange={(e) => channelsChange(e, i)}>
																<option value=''>Channels</option>
																{query.dropdown.map((e, i) => {
																	return <option key={i}>{e}</option>;
																})}
															</select>
														</div>
													)}
												</div>
											);
									  })
									: null}
								<div style={{ marginLeft: '3rem' }}></div>
								{metricQuery.length
									? metricQuery.map((query, i) => {
											return (
												<div key={i}>
													{query.type === 'dropdown' ? (
														<div className='mx-1'>
															<select
																type='select'
																name={query.field}
																className='form-select mr-2'
																value={query.value}
																onChange={(e) => queryMetricChange(e, i)}>
																<option value=''>Metrics</option>
																{query.dropdown.map((e, i) => {
																	return <option key={i}>{e}</option>;
																})}
															</select>
														</div>
													) : (
														<div className='mx-1' style={{ width: '12rem' }}>
															<input
																type={query.type === 'date' ? 'date' : query.type === 'number' ? 'number' : 'text'}
																name={query.field}
																className='form-select mr-1'
																value={query.value}
																placeholder={query.label}
																onChange={(e) => queryMetricChange(e, i)}></input>
														</div>
													)}
												</div>
											);
									  })
									: null}
							</div>
							{/* {clientData.length ? ( */}
							<div>
								<button onClick={() => filterMetric()} className='summary-button'>
									Filter
								</button>
								<button onClick={() => resetMetricInput()} className='summary-button'>
									Reset
								</button>
							</div>
							{/* ) : null} */}
						</div>
						{loading ? (
							<Loader />
						) : (
							<div className='px-3' id='summary-chart-table'>
								<div className='graph-body-border summary-chart-box mb-4' style={{ height: '470px' }}>
									<div className='d-flex justify-content-end pe-3'>
										<small
											style={{ cursor: 'pointer', textDecoration: 'underline' }}
											onClick={() => setShowTable(!showTable)}>
											{showTable ? 'Show Line' : 'Show Table'}
										</small>
									</div>
									{showTable ? (
										<LineTableView
											metricField={metricField}
											metricData={metricData}
											channels={channels}
											metricInitialVal={metricInitialVal}
										/>
									) : (
										<SummaryLineChart
											metricField={metricField}
											metricData={metricData}
											channels={channels}
											metricInitialVal={metricInitialVal}
										/>
									)}
								</div>

								<div className='d-flex justify-content-between'>
									<div
										className='graph-body-border summary-chart-box-400'
										style={{ width: '70%' }}
										id='metric-line-chart'>
										<div className='d-flex justify-content-end pe-3'>
											<small
												style={{
													cursor: 'pointer',
													textDecoration: 'underline',
												}}
												onClick={() => setShowTable2(!showTable2)}>
												{showTable ? 'Show Line' : 'Show Table'}
											</small>
										</div>

										{showTable2 ? (
											<MetricTableView metricData={metricData} height='300px' />
										) : (
											<LineChartMetric
												metricField={metricField}
												metricData={metricData}
												channels={channels}
												metricInitialVal={metricInitialVal}
											/>
										)}
									</div>
									<div
										className='graph-body-border summary-chart-box-400'
										style={{ width: '28%' }}
										id='metric-table-chart'>
										<TableChart
											metricField={metricField}
											metricData={metricData}
											channels={channels}
											metricInitialVal={metricInitialVal}
										/>
									</div>
								</div>
								<div className='d-flex justify-content-between mt-5'>
									<div
										className='graph-body-border summary-chart-box'
										style={{ width: '58%' }}
										id='metric-horizon-chart'>
										<SummaryLeftBar
											metricField={metricField}
											metricData={metricData}
											channels={channels}
											metricInitialVal={metricInitialVal}
										/>
									</div>
									<div
										className='summary-chart-box'
										id='metric-pie-chart'
										style={{
											width: '40%',
											borderRadius: '5px',
										}}>
										<SummaryPieChart
											metricField={metricField}
											metricData={metricData}
											channels={channels}
											metricInitialVal={metricInitialVal}
										/>
									</div>
								</div>

								{hideFilerFields ? null : (
									<div className='d-flex justify-content-between mt-5 mb-3'>
										<div>
											<div className='d-flex flex-wrap'>
												{salesSku.length
													? salesSku.map((query, i) => {
															return (
																<div key={i}>
																	{query.type === 'dropdown' && (
																		<div className='mx-2' style={{ width: '12rem' }}>
																			<select
																				type='select'
																				name={query.field}
																				className='form-select mr-2'
																				value={query.value}
																				onChange={(e) => salesFieldChange(e, i)}>
																				<option value=''>{query.label}</option>
																				{query.dropdown.map((e, i) => {
																					return <option key={i}>{e}</option>;
																				})}
																			</select>
																		</div>
																	)}
																</div>
															);
													  })
													: null}

												{salesQuery.length
													? salesQuery.map((query, i) => {
															return (
																<div key={i}>
																	{query.type === 'dropdown' ? (
																		<div className='mx-2'>
																			<select
																				type='select'
																				name={query.field}
																				className='form-select mr-2'
																				value={query.value}
																				onChange={(e) => querySalesChange(e, i)}>
																				<option value=''>Sales</option>
																				{query.dropdown.map((e, i) => {
																					return <option key={i}>{e}</option>;
																				})}
																			</select>
																		</div>
																	) : (
																		<div className='mx-3' style={{ width: '12rem' }}>
																			<input
																				type={
																					query.type === 'date' ? 'date' : query.type === 'number' ? 'number' : 'text'
																				}
																				name={query.field}
																				className='form-select mr-3'
																				value={query.value}
																				placeholder={query.label}
																				onChange={(e) => querySalesChange(e, i)}></input>
																		</div>
																	)}
																</div>
															);
													  })
													: null}
												<div className='mx-2'>
													<button onClick={() => filterSales()} className='summary-button'>
														Filter
													</button>
													<button onClick={() => resetSalesInput()} className='summary-button'>
														Reset
													</button>
												</div>
											</div>
										</div>
										<div>
											<div className='mx-3'>
												<div
													className='badge rounded-pill bg-success download-btn'
													onClick={() => downloadChart('sales-line-chart', 'sales-line-chart')}>
													Line <HiDownload />
												</div>
												<div
													className='mx-1 badge rounded-pill bg-success download-btn'
													onClick={() => downloadChart('sales-pie-chart', 'sales-pie-chart')}>
													Donut <HiDownload />
												</div>
												<div
													className='badge rounded-pill bg-success download-btn'
													onClick={() => downloadChart('sales-horizon-chart', 'sales-horizon-chart')}>
													H-Line <HiDownload />
												</div>
											</div>
										</div>
									</div>
								)}

								<div className='d-flex justify-content-between'>
									<div
										className='graph-body-border summary-chart-box-400'
										style={{ width: '70%', height: '500px' }}
										id='sales-line-chart'>
										<div className='d-flex justify-content-end pe-3'>
											<small
												style={{
													cursor: 'pointer',
													textDecoration: 'underline',
												}}
												onClick={() => setShowSalesTable(!showSalesTable)}>
												{showSalesTable ? 'Show Line' : 'Show Table'}
											</small>
										</div>

										{showSalesTable ? (
											<SalesTableView
												salesSku={salesSku}
												salesQuery={salesQuery}
												salesData={salesData}
												height='400px'
											/>
										) : (
											<SalesLineChart salesSku={salesSku} salesQuery={salesQuery} salesData={salesData} />
										)}
									</div>

									<div
										className='graph-body-border summary-chart-box-400'
										style={{
											width: '28%',
											height: '500px',
										}}
										id='metric-table-chart'>
										<TopSalesTable salesSku={salesSku} salesQuery={salesQuery} salesData={salesData} />
									</div>
								</div>
								<div className='d-flex justify-content-between mt-5'>
									<div className='graph-body-border summary-chart-box' style={{ width: '40%' }} id='sales-pie-chart'>
										<SalesPieChart salesSku={salesSku} salesQuery={salesQuery} salesData={salesData} />
									</div>
									<div
										className='graph-body-border summary-chart-box'
										style={{ width: '58%' }}
										id='sales-horizon-chart'>
										<SalesLeftBar salesSku={salesSku} salesQuery={salesQuery} salesData={salesData} />
									</div>
								</div>
							</div>
						)}
					</div>
				</>
			)}
		</div>
	);
};

export default SummaryDashboard;
